module.exports = __webpack_public_path__ + "static/media/dwt-05.372e8b73.jpg";